<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Administrador de PDFs</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_accion">
            <div>
                <v-text-field
                    v-model="searchPDF"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                    :disabled="isLoading"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    @click="getPDFByUser()"
                    class="mr-2"
                    :disabled="isLoading"
                ></v-btn>
                <v-btn
                    prepend-icon="mdi-plus"
                    color="indigo-darken-3"
                    class="elevation-0 text-none"
                    @click="dialogPDF = true"
                    :disabled="isLoading"
                    v-if="permission.uploadPDF"
                    text="Registrar"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            :headers="dataSource.headers"
            :items="dataSource.data"
            :search="searchPDF"
            :loading="isLoading || isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        >
            <template v-slot:[`item.actions`]="{ item }">
                <td>
                    <v-tooltip text="Descargar" location="bottom" v-if="permission.viewPDF">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0 mr-1"
                                density="comfortable"
                                icon="mdi-download"
                                color="indigo-darken-3"
                                :disabled="isLoading || isLoading"
                                @click="downloadPDF(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>

                    <v-tooltip text="Eliminar" location="bottom" v-if="permission.deletePDF">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0 mr-1"
                                density="comfortable"
                                icon="mdi-delete"
                                color="error"
                                :disabled="isLoading || isLoading"
                                @click="deleteItemPDF(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información del PDF</div>
    </div>

    <template>
        <v-dialog v-model="dialogPDF" width="600px" persistent>
            <v-card>
                <v-card-title class="text-h5">Registro de PDF</v-card-title>
                <v-card-text>
                    <form class="override_content_flex">
                        <div class="col-flex-12">
                            <v-file-input
                                label="Clic para subir su documento"
                                variant="outlined"
                                v-model="inputPDF"
                                :rules="rulePDF"
                                accept="application/pdf"
                            ></v-file-input>
                        </div>
                    </form>
                </v-card-text>
                <v-card-actions class="actions_buttons">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogPDF = false; inputPDF = null;"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        :loading="isLoading" 
                        :disabled="inputPDF === null" 
                        @click="dialogSavePDF = true"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogSavePDF" width="400px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Confirmación</span>
                </v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p>¿Está seguro de registrar el PDF?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Registrando la información</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons" v-if="!isLoading">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogSavePDF = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="uploadPDF()" 
                        :loading="isLoading"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
      <v-dialog v-model="dialogUploadPDF" width="400px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Confirmación</span>
                </v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p>¿Está seguro de descargar el PDF?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Descargando el archivo</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons" v-if="!isLoading">
                    <v-btn
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogUploadPDF = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="getPathPDF()" 
                        :loading="isLoading"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
      </v-dialog>
    </template>

    <template>
      <v-dialog v-model="dialogDeletePDF" width="400px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Confirmación</span>
                </v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p>¿Está seguro de eliminar el PDF?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Eliminando el archivo</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons" v-if="!isLoading">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogDeletePDF = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        @click="deletePDF()"
                        :loading="isLoading"
                        text="Aceptar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
      </v-dialog>
    </template>

    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService'
import { ManagementsService } from '@/services/ManagementsService'
import { ResourcesService } from '@/services/ResourcesService'
import SnackbarComponent from '@/components/Snackbar'
import { useUiStore } from '@/stores/ui'
export default {
    name: "PDFManagementView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            idPDF: 0,
            idClient: null,
            searchPDF: '',
            isLoading: false,
            dialogPDF: false,
            dialogSavePDF: false,
            dialogUploadPDF: false,
            dialogDeletePDF: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dataSource: {
                data: [],
                headers: [
                    {
                        align: "start",
                        key: "ruta",
                        title: "Nombre del Documento",
                    },
                    {
                        key: "created_at",
                        title: "Fecha de Creación",
                    },
                    {
                        key: "agregado_por",
                        title: "Usuario Creador",
                    },
                    {
                        key: "actions",
                        title: "Acciones",
                    },
                ],
            },
            inputPDF: null,
            rulePDF: [
                value => {
                    if (value === null || value.length === 0 || value === undefined || value === '') {
                        return `El campo es obligatorio`
                    }

                    if (!(/\.pdf$/i.test(value[0].name))) {
                        return `El documento debe ser un archivo PDF`
                    }
                    return true
                }
            ],
            permission: {
                uploadPDF: false,
                deletePDF: false,
                viewPDF: false,
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
    },
    async mounted() {
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created() {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        const ENC_PERMISOS = localStorage.getItem('PERMISOS')
        const STR_PERMISOS = atob(ENC_PERMISOS)
        const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
        const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M12GEST')
        for (const element of PERMISSION.endpoints) {

            if (element.nombre === 'M12F01SUPD' && element.permiso === true) {
                this.permission.uploadPDF = true
            }
            if (element.nombre === 'M12F01ELPD' && element.permiso === true) {
                this.permission.deletePDF = true
            }
            if (element.nombre === 'M12F01VSPD' && element.permiso === true) {
                this.permission.viewPDF = true
            }
        }

        this.isLoading = true
        await this.getClientInformation()
        await this.getPDFByUser()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getPDFByUser: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getPDFByUser(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        for (let element of responseData.response) {
                            element.agregado_por = element.agregado_por === null ? 'N/A'  : element.agregado_por
                        }
                        this.dataSource.data = responseData.response
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        uploadPDF: async function () {
            this.isLoading = true
            const FILE  =this.inputPDF[0];
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            const USERNAME = localStorage.getItem('USERNAME')

            const formData = new FormData();
            formData.append('pdf', FILE)
            formData.append('id_cliente', ENC_CLIENT)
            formData.append('agregado_por', USERNAME)

            await ManagementsService.uploadPDF(formData).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Registro Exitoso!`
                        this.snackbarData.openSnackbar = true
                        await this.getPDFByUser()
                        this.inputPDF = null
                        this.dialogSavePDF = false
                        this.dialogPDF = false
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        getPathPDF: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idPDF.toString())
            await ManagementsService.getPathPDF(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        // window.location.href = `${responseData.response}`
                        window.open(`${responseData.response}`, '_blank')
                        this.dialogUploadPDF = false
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        deletePDF: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idPDF.toString())
            await ManagementsService.deletePDF(ENC_CLIENT).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Eliminación Exitosa!`
                        this.snackbarData.openSnackbar = true
                        await this.getPDFByUser()
                        this.dialogDeletePDF = false
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        downloadPDF: function (item) {
            this.idPDF = item.id_pdf
            this.dialogUploadPDF = true
        },
        deleteItemPDF: function (item) {
            this.idPDF = item.id_pdf
            this.dialogDeletePDF = true
        },
    },
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
</style>